import { CountryCodes, Currencies } from '../constants';

const defaultCountryCode = CountryCodes.NO;

export const getCurrencyFromCountryCode = (countryCode: CountryCodes = defaultCountryCode): string =>
    Currencies[countryCode] ?? Currencies[defaultCountryCode];
